import Vue from 'vue'
import VueRouter from 'vue-router'

import { canNavigate } from '@/libs/acl/routeProtection'
import {getHomeRouteForLoggedInUser, isUserLoggedIn} from '@/auth/utils'
import inicio from './routes/inicio'
import erros from './routes/erros'
import meusProdutos from './routes/meusProdutos'
import empresas from './routes/empresas'
import perfil from './routes/perfil'
import auth from './routes/auth'
import diversos from './routes/diversos'
import configuracoes from './routes/configuracoes'
import usuariosSesi from './routes/usuarios-sesi'
import modulos from './routes/modulos'
import ajudaSuporte from './routes/ajuda-suporte'
import minhaConta from './routes/minhaConta'
import relatorios from './routes/relatorios'
import { gerarRotasDinamicas } from './routes/powerBI'

Vue.use(VueRouter)

const rotas = () => [
  { path: '/', redirect: { name: 'bem-vindo' } },
  ...inicio,
  ...meusProdutos,
  ...empresas,
  ...perfil,
  ...auth,
  ...erros,
  ...diversos,
  ...configuracoes,
  ...usuariosSesi,
  ...minhaConta,
  ...ajudaSuporte,
  ...modulos,
  ...relatorios,
  ...gerarRotasDinamicas(),
  {
    path: '*',
    redirect: { name: 'error-404' },
  },
];

const createRouter = () => new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: rotas()
})

const router = createRouter()

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn();

  if (to.meta.resource === "AUTH" && isLoggedIn) {
      return next(getHomeRouteForLoggedInUser())
  }

  if(to.meta.resource === "ACL") {
    if (!isLoggedIn) return next({ name: 'auth-login' })

    if (!canNavigate(to)) {
      return next({ name: 'misc-not-authorized' })
    }
  }

  return next()
})

router.afterEach((to, _from) => {
    const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = 'none'
    }
    Vue.nextTick(() => {
        document.title = to.meta.title || 'Cliente Sesi+Saúde';
    });
})

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export default router
